module.exports = __webpack_public_path__ + "media/images/iconRight__okGreen-2ce44456cf9b96c4c17359bbc920ad49.png";